/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AttributeDetailInfo} from '../models/AttributeDetailInfo';
import type {AttributeRelationInfo} from '../models/AttributeRelationInfo';
import type {AttributeUsage} from '../models/AttributeUsage';
import type {Error} from '../models/Error';
import type {UserEventAttributeDetailInfo} from '../models/UserEventAttributeDetailInfo';

export interface GetAllAttributeRelationInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllAttributeRelationInfoRequest = createAction<PayloadData<void>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTE_RELATION_INFO__REQUEST');
export const getAllAttributeRelationInfoSuccess = createAction<PayloadData<Array<AttributeRelationInfo>>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTE_RELATION_INFO__SUCCESS');
export const getAllAttributeRelationInfoFailure = createAction<PayloadData<Error, void, true>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTE_RELATION_INFO__FAILURE');

export const getAllAttributeRelationInfoActions = [
    getAllAttributeRelationInfoRequest,
    getAllAttributeRelationInfoSuccess,
    getAllAttributeRelationInfoFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllAttributeRelationInfo = (config?: GetAllAttributeRelationInfo$Config) => {
    return {
        CALL_API: {
            types: getAllAttributeRelationInfoActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/relation-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetAllAttributes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllAttributesRequest = createAction<PayloadData<void>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES__REQUEST');
export const getAllAttributesSuccess = createAction<PayloadData<Array<AttributeDetailInfo>>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES__SUCCESS');
export const getAllAttributesFailure = createAction<PayloadData<Error, void, true>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES__FAILURE');

export const getAllAttributesActions = [
    getAllAttributesRequest,
    getAllAttributesSuccess,
    getAllAttributesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllAttributes = (config?: GetAllAttributes$Config) => {
    return {
        CALL_API: {
            types: getAllAttributesActions,
            method: ApiMethods.GET,
            endpoint: `/attributes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetAllAttributesByName$Request {
    name: string;
}

export interface GetAllAttributesByName$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllAttributesByNameRequest = createAction<PayloadData<void, GetAllAttributesByName$Request>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES_BY_NAME__REQUEST');
export const getAllAttributesByNameSuccess = createAction<PayloadData<Array<AttributeDetailInfo>, GetAllAttributesByName$Request>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES_BY_NAME__SUCCESS');
export const getAllAttributesByNameFailure = createAction<PayloadData<Error, GetAllAttributesByName$Request, true>>('ATTRIBUTE_CONTROLLER__GET_ALL_ATTRIBUTES_BY_NAME__FAILURE');

export const getAllAttributesByNameActions = [
    getAllAttributesByNameRequest,
    getAllAttributesByNameSuccess,
    getAllAttributesByNameFailure
] as const;

/**
 * @param {string} meta.name Attribute name
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllAttributesByName = (meta: GetAllAttributesByName$Request, config?: GetAllAttributesByName$Config) => {
    return {
        CALL_API: {
            types: getAllAttributesByNameActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/${meta.name}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAllUserEventAttributes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllUserEventAttributesRequest = createAction<PayloadData<void>>('ATTRIBUTE_CONTROLLER__GET_ALL_USER_EVENT_ATTRIBUTES__REQUEST');
export const getAllUserEventAttributesSuccess = createAction<PayloadData<Array<UserEventAttributeDetailInfo>>>('ATTRIBUTE_CONTROLLER__GET_ALL_USER_EVENT_ATTRIBUTES__SUCCESS');
export const getAllUserEventAttributesFailure = createAction<PayloadData<Error, void, true>>('ATTRIBUTE_CONTROLLER__GET_ALL_USER_EVENT_ATTRIBUTES__FAILURE');

export const getAllUserEventAttributesActions = [
    getAllUserEventAttributesRequest,
    getAllUserEventAttributesSuccess,
    getAllUserEventAttributesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllUserEventAttributes = (config?: GetAllUserEventAttributes$Config) => {
    return {
        CALL_API: {
            types: getAllUserEventAttributesActions,
            method: ApiMethods.GET,
            endpoint: `/public/attributes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetAttributeDescriptionSuggestions$Request {
    name: string;
}

export interface GetAttributeDescriptionSuggestions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttributeDescriptionSuggestionsRequest = createAction<PayloadData<void, GetAttributeDescriptionSuggestions$Request>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTE_DESCRIPTION_SUGGESTIONS__REQUEST');
export const getAttributeDescriptionSuggestionsSuccess = createAction<PayloadData<Array<string>, GetAttributeDescriptionSuggestions$Request>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTE_DESCRIPTION_SUGGESTIONS__SUCCESS');
export const getAttributeDescriptionSuggestionsFailure = createAction<PayloadData<Error, GetAttributeDescriptionSuggestions$Request, true>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTE_DESCRIPTION_SUGGESTIONS__FAILURE');

export const getAttributeDescriptionSuggestionsActions = [
    getAttributeDescriptionSuggestionsRequest,
    getAttributeDescriptionSuggestionsSuccess,
    getAttributeDescriptionSuggestionsFailure
] as const;

/**
 * @param {string} meta.name Attribute name
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttributeDescriptionSuggestions = (meta: GetAttributeDescriptionSuggestions$Request, config?: GetAttributeDescriptionSuggestions$Config) => {
    return {
        CALL_API: {
            types: getAttributeDescriptionSuggestionsActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/description-suggestions/${meta.name}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAttributesUsageByIds$Request {
    ids: Array<number>;
}

export interface GetAttributesUsageByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAttributesUsageByIdsRequest = createAction<PayloadData<void, GetAttributesUsageByIds$Request>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTES_USAGE_BY_IDS__REQUEST');
export const getAttributesUsageByIdsSuccess = createAction<PayloadData<Array<AttributeUsage>, GetAttributesUsageByIds$Request>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTES_USAGE_BY_IDS__SUCCESS');
export const getAttributesUsageByIdsFailure = createAction<PayloadData<Error, GetAttributesUsageByIds$Request, true>>('ATTRIBUTE_CONTROLLER__GET_ATTRIBUTES_USAGE_BY_IDS__FAILURE');

export const getAttributesUsageByIdsActions = [
    getAttributesUsageByIdsRequest,
    getAttributesUsageByIdsSuccess,
    getAttributesUsageByIdsFailure
] as const;

/**
 * @param {Array<number>} meta.ids Attribute Ids
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAttributesUsageByIds = (meta: GetAttributesUsageByIds$Request, config?: GetAttributesUsageByIds$Config) => {
    const TRANSPORT_GET_PARAMS = {
        ids: meta.ids,
    };
    return {
        CALL_API: {
            types: getAttributesUsageByIdsActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/usage`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUniqueAttributeTitleCount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUniqueAttributeTitleCountRequest = createAction<PayloadData<void>>('ATTRIBUTE_CONTROLLER__GET_UNIQUE_ATTRIBUTE_TITLE_COUNT__REQUEST');
export const getUniqueAttributeTitleCountSuccess = createAction<PayloadData<number>>('ATTRIBUTE_CONTROLLER__GET_UNIQUE_ATTRIBUTE_TITLE_COUNT__SUCCESS');
export const getUniqueAttributeTitleCountFailure = createAction<PayloadData<Error, void, true>>('ATTRIBUTE_CONTROLLER__GET_UNIQUE_ATTRIBUTE_TITLE_COUNT__FAILURE');

export const getUniqueAttributeTitleCountActions = [
    getUniqueAttributeTitleCountRequest,
    getUniqueAttributeTitleCountSuccess,
    getUniqueAttributeTitleCountFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUniqueAttributeTitleCount = (config?: GetUniqueAttributeTitleCount$Config) => {
    return {
        CALL_API: {
            types: getUniqueAttributeTitleCountActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/unique-title-count`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface RemoveAttributeById$Request {
    id: number;
}

export interface RemoveAttributeById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeAttributeByIdRequest = createAction<PayloadData<void, RemoveAttributeById$Request>>('ATTRIBUTE_CONTROLLER__REMOVE_ATTRIBUTE_BY_ID__REQUEST');
export const removeAttributeByIdSuccess = createAction<PayloadData<void, RemoveAttributeById$Request>>('ATTRIBUTE_CONTROLLER__REMOVE_ATTRIBUTE_BY_ID__SUCCESS');
export const removeAttributeByIdFailure = createAction<PayloadData<Error, RemoveAttributeById$Request, true>>('ATTRIBUTE_CONTROLLER__REMOVE_ATTRIBUTE_BY_ID__FAILURE');

export const removeAttributeByIdActions = [
    removeAttributeByIdRequest,
    removeAttributeByIdSuccess,
    removeAttributeByIdFailure
] as const;

/**
 * @param {number} meta.id Attribute Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeAttributeById = (meta: RemoveAttributeById$Request, config?: RemoveAttributeById$Config) => {
    return {
        CALL_API: {
            types: removeAttributeByIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/attributes/remove/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

